import { render, staticRenderFns } from "./kpi-bar.component.vue?vue&type=template&id=2c49bee2&scoped=true"
import script from "./kpi-bar.component.vue?vue&type=script&lang=ts"
export * from "./kpi-bar.component.vue?vue&type=script&lang=ts"
import style0 from "./kpi-bar.component.vue?vue&type=style&index=0&id=2c49bee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c49bee2",
  null
  
)

export default component.exports